import { FuseAnimate } from '@fuse'
import {
  Button,
  CircularProgress,
  Divider,
  Icon,
  IconButton,
  Typography,
  useMediaQuery,
} from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import { makeStyles } from '@material-ui/styles'
import { denormalizeEmptyParagraphs } from 'app/main/composeMessage/tiptapEditor/TiptapUtils'
import clsx from 'clsx'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import {
  __,
  compose,
  equals,
  filter,
  find,
  gt,
  inc,
  includes,
  isEmpty,
  isNil,
  length,
  map,
  not,
  path,
  prop,
  propEq,
  propOr,
  toLower,
} from 'ramda'
import { first, compact, some } from 'lodash'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { MESSAGE_CREDIT_NOT_ENOUGH_CODE } from '../notification/messageCreditAlertDialog/utils'
//-----------------------
import { Routes } from 'app/services/routeService/routeService'
import { usePlace } from 'commons/usePlace'

import { AccessType } from 'app/auth/accessControlService'
import { useAccessControl } from 'app/auth/useAccessControl'
import ResponsiveDialogAction from 'app/components/dialog/ResponsiveDialogAction'
import { ImageAiIcon, QuestionIcon, RateAiIcon } from 'app/components/icons'
import Loader from 'app/components/Loader'
import Assets from 'app/configs/assetConfigs'
import { API_DATE_FORMATTED } from 'libs/dateUtils'
import { isEmptyOrNil } from 'libs/empty'
import { htmlToPlainText } from 'libs/text'

import DraftNotificationPopup from 'app/main/draftNotification/DraftNotificationPopup'
import CreateNotificationOverdraftDialog from 'app/main/notification/CreateNotificationOverdraftDialog'

import DateTimeFormik from 'app/components/formik/dateTime/DateTimeFormik'
import TimezoneFormik from 'app/components/formik/timezone/TimezoneFormik'

import PrimaryRouterLink from 'app/components/buttons/PrimaryRouterLink'
import PrimaryTooltip from 'app/componentV4/Tooltip/PrimaryTooltip'

// ----------------------- Start new compose --------------

import ChannelSelector from 'app/main/composeMessage/channels/ChannelSelector'
import ComposeRightTab from 'app/main/composeMessage/ComposeRightTab'
import DoNotTranslateEditorFormik from 'app/main/composeMessage/editor/DoNotTranslateEditorFormik'
import { PlacesAddressAutocompleteFormik } from 'app/main/composeMessage/location'
import { mapToPreview } from 'app/main/composeMessage/mapping'
import MessageExpirationSelector from 'app/main/composeMessage/messageExpiration/MessageExpirationSelector'
import MessagePrioritySelector from 'app/main/composeMessage/messagePriority/MessagePrioritySelector'
import MessageTypeSelector from 'app/main/composeMessage/messageType/MessageTypeSelector'
import TopicSelector from 'app/main/composeMessage/topics/TopicSelector'
import AttachVoucherSelector from 'app/main/composeMessage/vouchers/AttachVoucherSelector'
import { useComposeMessage } from './useComposeMessage'

import RecipientsSelector from 'app/main/composeMessage/recipients/RecipientsSelector'

import MessageCreditAlert from 'app/main/composeMessage/credits/MessageCreditAlert'
import MessageOptionFormik from 'app/main/composeMessage/messageOption/MessageOptionFormik'
import PreviewMessage from 'app/main/composeMessage/preview/PreviewMessage'
import PreviewMessageV4 from 'app/main/composeMessage/preview/v4/PreviewMessage'
import ShotNameInput from 'app/main/composeMessage/shortName/ShotNameInput'
import SocialMediaSetting from 'app/main/composeMessage/socials/SocialMediaSetting'
import SubscriberCount from 'app/main/composeMessage/subscribers/SubscriberCount'
// ----------------------- End new compose --------------

//-------------------- start ai --------------------------------
import GenerateImageWithAIDialog from 'app/main/ai/GenerateImageWithAIDialog'
import GenerateTextWithAIDialog from 'app/main/ai/GenerateTextWithAIDialog'
import RateWithAIDialog from 'app/main/ai/RateWithAIDialog'
import { useGenerateImageWithAI } from 'app/main/ai/useGenerateImageWithAI'
import { useGenerateTextWithAI } from 'app/main/ai/useGenerateTextWithAI'
import { useRateWithAI } from 'app/main/ai/useRateWithAI'
//-------------------- end ai --------------------------------

import { clearInitailValue, onChangeTypeDialog } from 'app/auth/store/actions'
import GenerateWithAIButton from 'app/components/buttons/GenerateWithAIButton'
import SecondaryButton from 'app/components/buttons/SecondaryButton'
import IosSwitchFormik from 'app/components/IosSwitchFormik'
import ContainedButton from 'app/componentV4/Button/ContainedButton'
import CheckBox from 'app/componentV4/CheckBox'
import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'
import FrequencyTypeSelector from 'app/componentV4/frequencys/FrequencyTypeSelector'
import DynamicTextInput from 'app/componentV4/Input/DynamicTextInput'
import SimpleInput from 'app/componentV4/Input/SimpleInput'
import SelectorFormik from 'app/componentV4/selectors/SelectorFormik'
import { CANCEL, CLOSE, SECONDARY } from 'app/constants/button'
import BeaconRange from 'app/main/composeMessage/beacons/BeaconRange'
import BeaconSelector from 'app/main/composeMessage/beacons/BeaconSelector'
import {
  getProximityLength,
  getRangeOptions,
  getUnitShortName,
  getUnitText,
  useBeacon,
} from 'app/main/composeMessage/beacons/useBeacon'
import TranslationPreview from 'app/main/messages/notificationTimeline/notification-preview/TranslationPreview'
import { localStorageService } from 'app/services/localStorageService/localStorageService'
import { useDispatch } from 'react-redux'
import { useFlag } from '@unleash/proxy-client-react'
import CMAITour, { TOUR_CM_AI } from '../BeginerGuideTour/CMAITour'

import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined'
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined'
import OutlinedButtons from 'app/componentV4/Button/OutlinedButtons'
import CollapsePanelV2 from 'app/componentV4/Collapses/CollapsePanelV2'
import {
  CHANNEL_CALL,
  CHANNEL_SMS,
  FACEBOOK_VALUE,
  INSTAGRAM_VALUE,
  LINKEDIN_VALUE,
  SUBSCRIBER_COUNT,
  TWITTER_VALUE,
} from 'app/constants/channel'
import {
  BEACON_DIALOG,
  GENERAL_DIALOG,
  MAX_PLACE_NAME_FOR_SMS,
  TEXT_EDITOR_CONTROLS,
  TITLE_MAX_LENGTH,
  TYPE_SEND_NOW,
  TYPE_SEND_SCHEDULE,
} from 'app/constants/compose'
import { TYPE_EVENT, TYPE_GENERAL, TYPE_POLL } from 'app/constants/messageType'
import GVAImagesAITour, {
  GVA_IMAGE_AI_FIRST_STEP_TOUR,
  TOUR_RATE_ENHANCE,
} from '../BeginerGuideTour/GVAImagesAITour'
import MoreOptionTitle from './MoreOptionTitle'
import TiptapEditor from './tiptapEditor/TiptapEditor'
import { addImageKitToBaseUrl } from './tiptapEditor/TiptapUtils'
import { removeBodyImageFromEditor } from './tiptapEditor/useTiptapEditor'
import useFeatureFlag from 'app/configs/useFeatureFlag'
import Attachments from './attachments/attachments'
import apiConfigs from 'app/configs/apiConfigs'

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiOutlinedInput-input': {
      padding: '14px 32px 14px 15px !important',
    },
  },
  editor: {
    '& .fr-svg': {
      height: ' 22px !important',
      width: '22px !important',
      margin: '6px 5px',
    },
  },
  heightContainer: {
    height: 'fit-content',
    [theme.breakpoints.up('md')]: {
      height: 'calc(100vh - 150px)',
    },
  },
  container: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 'calc(100% - 32rem)',
    },
  },
  title: {
    height: '60px',
  },
  body: {
    height: '92vh',
  },
  item: {
    width: 'auto',
    maxWidth: 'calc(100vw - 25px)',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 'calc(100vw - 90px)',
    },
  },
  timezone: {
    '& .MuiAutocomplete-endAdornment': {
      display: 'block !important',
    },
    '& .MuiAutocomplete-clearIndicator': {
      display: 'none !important',
    },
    '& .MuiAutocomplete-input': {
      fontSize: '12px !important',
    },
  },
  reminderInfo: {
    color: theme.palette.secondary.main,
    marginTop: 5,
    marginBottom: 16,
  },
  rigthBar: {
    // marginRight: '6.2rem !important',
    marginBottom: '60px',
  },
  topBar: {
    boxShadow: '0 1px rgba(0,0,0,0.10) !important',
    '& .MuiTypography-h6': {
      height: '100%',
    },
  },
  noBorder: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 0,
    },
  },
  inputBorderError: {
    '& .MuiInputBase-root': {
      border: '1px solid red !important',
      borderRadius: '4px',
    },
  },
  placeAddress: {
    '& .MuiOutlinedInput-root': {
      border: 0,
    },
    '& fieldset': {
      border: '1px solid #C5C5C5 !important',
    },
    '& input': {
      border: 0,
    },
  },
  placeAddressError: {
    '& .MuiOutlinedInput-root': {
      border: 0,
    },
    '& fieldset': {
      border: '1px solid red !important',
    },
    '& input': {
      border: 0,
    },
  },
  submitDialog: {
    color: theme.colors.primary,
    '& .submit-dialog': {
      width: '375px',
      '& .button-submit': {
        backgroundColor: theme.colors['primary'],
        color: theme.palette.light.main,
        textTransform: 'none',
        padding: '0.75rem 1.25rem',
        '&:hover': {
          backgroundColor: theme.colors['primary'],
        },
        '&:action': {
          backgroundColor: theme.colors['primary'],
        },
      },
      '& .button-close': {
        textTransform: 'none',
        padding: '0.75rem 1.25rem',
        color: theme.colors['grey-200'],
        border: '1px solid',
        borderColor: theme.colors['grey-200'],
        borderRadius: '4px',
        backgroundColor: 'transparent !important',
        '&:hover': {
          color: theme.colors['grey-400'],
          borderColor: theme.colors['grey-400'],
        },
        '&:action': {
          color: theme.colors['grey-300'],
          borderColor: theme.colors['grey-300'],
        },
      },
    },
  },
  mainContent: {
    paddingTop: '60px',
    paddingBottom: '60px',
  },
  rightBar: {
    top: '60px',
    bottom: '60px',
  },
  footer: {
    height: '60px',
  },
}))

const ComposeMessageDialog = (props) => {
  const {
    formik,
    notification,
    onClose,
    isDraft,
    dialogType,
    submitNoti,
    submitDraft,
    isSubmitting,
    submitErrorDetails,
    onSubmitting,
    valueFromAnotherPage,
    isCopyMessage,
  } = props

  const { mes_4367_attachment_gallery } = useFeatureFlag()
  const { mes_3198_poll_preview_translation } = useFeatureFlag()

  const dispatch = useDispatch()
  const {
    state: { beacons, isLoading },
    fetchBeacons,
  } = useBeacon()
  const isBeaconDialog = dialogType === BEACON_DIALOG
  const footerRef = useRef(null)
  const { mes_2175_new_live_preview } = useFeatureFlag()
  const mes_5281_save_draft_for_polls = useFlag('mes_5281_save_draft_for_polls')

  const { isGranted: isAdmin } = useAccessControl([AccessType.ADMINISTRATION])
  const theme = useTheme()
  const classStyle = useStyles()
  const isDownXs = useMediaQuery(theme.breakpoints.down('xs'))
  const place = usePlace()

  const isBeaconEnabled = path(['info', 'isBeaconEnabled'], place)
  const [bodyEditor, setBodyEditor] = useState(null)
  const { formatMessage } = useIntl()

  const [isOpenPreview, setIsOpenPreview] = useState(false)
  const [uploadingCount, setUploadingCount] = useState(0)
  const [isClosingDialogWarning, setIsClosingDialogWarning] = useState(false)
  const [isDraftPopupSubmitting, setIsDraftPopupSubmitting] = useState(false)
  const [isOverDraftDialog, setIsOverDraftDialog] = useState(false)
  const [isOpenSwitchDialog, setIsOpenSwitchDialog] = useState(false)
  const [confirmBeaconCloseDialog, setConfirmBeaconCloseDialog] =
    useState(false)
  const [isAttachmentsLoading, setIsAttachmentsLoading] = useState(false)

  const isPoll = formik.values.notiType === TYPE_POLL
  const [imageInfo, setImageInfo] = useState([])
  // initialModel
  const editId = prop('id', notification)
  const isSent = propOr(false, 'isSent', notification)
  const isEditMode =
    compose(not, isEmptyOrNil)(editId) && !isDraft && !isCopyMessage
  const isUploadingFiles = uploadingCount !== 0
  const scrollableContainerId = 'scrollable-container'
  const scrollableContainerSelector = `#${scrollableContainerId}`
  const requestId = props.requestId

  const {
    state: {
      subscriberTotal,
      channelSetting,
      topicsOptions,
      vouchersOptions,
      isShowHelpTab,
      isShowSettingTab,
      isLoadingTopics,
      minStartEvent,
      maxStartEvent,
      minEndEvent,
      maxEndEvent,
      minSchedule,
      maxSchedule,
      minReminder,
      maxReminder,
      isScheduleDisabled,
      isLoadingSubscriberTotal,
      isChannelLoading,
      isOpenCredit,
      isShowMessageRatioMessage,
      aiGenerateTextUpdated,
      minStartScheduleBeacon,
      maxStartScheduleBeacon,
      minEndScheduleBeacon,
      maxEndScheduleBeacon,
      maxEndPoll,
      minEndPoll,
    },
    fetchVouchers,
    onScheduleTimezoneChange,
    onMessageOptionChange,
    onEventStartDateChange,
    onEventTimezoneChange,
    onVoucherChange,
    onCheckedReminder,
    onNotificationTypeChange,
    onRecipientChange,
    onTopicsChange,
    onChannelsChange,
    onSharingEnabledChange,
    onHandleTtsdisabled,
    onBodyInsertImage,
    handleFirstMount,
    onExpirationChange,
    checkSocialChannelOnly,
    onScheduleChange,
    toggleHelpTab,
    toggleSettingTab,
    onCloseRightTab,
    onReplaceWithAIVersionClick,
    closeCredit,
    setChannelLoading,
    openCreditDialog,
    onRoomSizeChange,
    onRangeChange,
    onAddEndDateSchedule,
    onScheduleStartDateChange,
    onScheduleBeaconTimezoneChange,
    dispatchShowMessageRatio,
    onScheduleEndDateChange,
    onPollEndChange,
    onContentGeneratedWithAI,
  } = useComposeMessage(
    notification,
    isEditMode,
    isDraft,
    isBeaconDialog,
    isCopyMessage,
    {
      current: bodyEditor,
    },
  )

  const proximityLengthOptions = getProximityLength(formatMessage)
  const generateTextWithAI = useGenerateTextWithAI(
    requestId,
    {
      current: bodyEditor,
    },
    onContentGeneratedWithAI,
  )

  const hancleImageChange = React.useCallback(
    ({ path, name }) => {
      const newItem = { path, name }

      setImageInfo((prevImageInfo) => {
        const updated = [
          ...prevImageInfo,
          {
            ...newItem,
            isSelected: isEmpty(prevImageInfo),
          },
        ]

        setTimeout(() => {
          onBodyInsertImage?.(prevImageInfo, newItem)
        }, 0)

        return updated
      })
    },
    [onBodyInsertImage],
  )

  const handleInsertImage = React.useCallback(
    (imageURL, imageName) => {
      if (!bodyEditor) return
      const alt = imageName || 'AI Generated Image'
      bodyEditor
        .chain()
        .focus()
        .setImage({
          src: addImageKitToBaseUrl(imageURL),
          alt,
        })
        .run()

      if (!mes_4367_attachment_gallery) {
        hancleImageChange({
          path: imageURL,
          name: imageName,
        })
      }
    },
    [bodyEditor, hancleImageChange, mes_4367_attachment_gallery],
  )

  const mediaSocialsRef = useRef(formik.values.mediaSocials)
  const pendingBodyImagesRef = useRef([])
  const flushBodyImagesRef = useRef(false)
  const pendingRemovedBodyImageIdsRef = useRef([])
  const flushRemovedBodyImagesRef = useRef(false)
  const handleDeleteAllAttachments = useCallback(() => {
    mediaSocialsRef.current = []
  }, [])

  useEffect(() => {
    mediaSocialsRef.current = formik.values.mediaSocials
  }, [formik.values.mediaSocials])

  const handleBodyImageAdded = useCallback(
    (imageData) => {
      if (!mes_4367_attachment_gallery) return
      pendingBodyImagesRef.current = [
        ...pendingBodyImagesRef.current,
        imageData,
      ]
      if (flushBodyImagesRef.current) return
      flushBodyImagesRef.current = true
      Promise.resolve().then(() => {
        const currentImages = mediaSocialsRef.current || []
        const pending = pendingBodyImagesRef.current
        pendingBodyImagesRef.current = []
        flushBodyImagesRef.current = false
        if (!pending.length) return
        const isFirst = currentImages.length === 0
        const nextImages = [
          ...currentImages,
          ...pending.map((img, index) => ({
            bodyImageId: img.bodyImageId,
            url: img.url,
            name: img.name,
            size: img.size,
            isSelected: isFirst && index === 0,
            type: 'image',
            isLoading: false,
          })),
        ]
        mediaSocialsRef.current = nextImages
        formik.setFieldValue('mediaSocials', nextImages, false)
      })
    },
    [formik, mes_4367_attachment_gallery],
  )

  const handleBodyImageRemoved = useCallback(
    (bodyImageId) => {
      if (!mes_4367_attachment_gallery) return
      if (!mediaSocialsRef.current?.length) return
      if (!bodyImageId) return
      pendingRemovedBodyImageIdsRef.current = [
        ...pendingRemovedBodyImageIdsRef.current,
        bodyImageId,
      ]
      if (flushRemovedBodyImagesRef.current) return
      flushRemovedBodyImagesRef.current = true
      Promise.resolve().then(() => {
        const currentImages = mediaSocialsRef.current || []
        const removedIds = new Set(pendingRemovedBodyImageIdsRef.current)
        pendingRemovedBodyImageIdsRef.current = []
        flushRemovedBodyImagesRef.current = false
        if (!removedIds.size || currentImages.length === 0) return
        const removedImage = currentImages.find((img) =>
          removedIds.has(img.bodyImageId),
        )
        const filtered = currentImages.filter(
          (img) => !removedIds.has(img.bodyImageId),
        )
        const needsNewSelection =
          removedImage?.isSelected && filtered.length > 0
        const result = needsNewSelection
          ? filtered.map((img, i) =>
              i === 0 ? { ...img, isSelected: true } : img,
            )
          : filtered
        mediaSocialsRef.current = result
        formik.setFieldValue('mediaSocials', result, false)
      })
    },
    [formik, mes_4367_attachment_gallery],
  )

  const handleSyncedImageDelete = useCallback(
    (bodyImageId) => {
      if (!bodyEditor || !bodyImageId) return
      removeBodyImageFromEditor(bodyEditor, bodyImageId)
    },
    [bodyEditor],
  )

  const generateImageWithAI = useGenerateImageWithAI(
    requestId,
    handleInsertImage,
  )

  const rateWithAI = useRateWithAI(requestId, onReplaceWithAIVersionClick)

  const isAiCanceled =
    generateTextWithAI.isCancelGeneratingText ||
    generateImageWithAI.isCancelAiImagePreview ||
    rateWithAI.isCanceled

  const isAiExist =
    generateTextWithAI.isExistAiTextPreview ||
    generateImageWithAI.isExistAiImagePreview

  const onSubmitAiConfirmDialog = () => {
    if (generateTextWithAI.isCancelGeneratingText) {
      generateTextWithAI.onCancelConfirmClick()
    }
    if (generateImageWithAI.isCancelAiImagePreview) {
      generateImageWithAI.onCancelGenerateImageConfirmClick()
    }
    if (rateWithAI.isCanceled) {
      rateWithAI.onConfirmClick()
    }

    if (generateTextWithAI.isExistAiTextPreview) {
      generateTextWithAI.onExisTextConfirmClick()
    }

    if (generateImageWithAI.isExistAiImagePreview) {
      generateImageWithAI.onExistImageConfirmClick()
    }
  }

  const onCloseAiConfirmDialog = () => {
    if (isAiCanceled) {
      generateTextWithAI.onCloseCancel()
      generateImageWithAI.onCloseCancelGenerateImage()
      rateWithAI.onCloseDialogConfirm()
    } else {
      generateImageWithAI.onCloseExistConfirm()
      generateTextWithAI.onCloseExist()
    }
  }

  const isLoadingButtonSubmit =
    isUploadingFiles ||
    formik.isSubmitting ||
    isLoadingTopics ||
    isLoadingSubscriberTotal ||
    isChannelLoading ||
    isSubmitting ||
    formik.isValidating ||
    isAttachmentsLoading ||
    isDraftPopupSubmitting

  const isButtonDisabled =
    isLoadingButtonSubmit || isSubmitting || !!formik.errors.mediaSocials

  const isNotSaveDraft = isEditMode && !isDraft

  const isSocialChannelOnly =
    formik.values.recipients.subGroups.length === 0 &&
    formik.values.recipients.subscribers.length === 0
      ? checkSocialChannelOnly(formik.values.channels.channelIds)
      : false

  const isEventStartDatedisabled =
    !isNil(formik.initialValues.eventStartDateTime) && isEditMode && !isDraft
      ? moment(formik.initialValues.eventStartDateTime).isBefore(
          moment().set({ second: 0 }),
        )
      : false

  const isEndpPollToDay = !isNil(formik.values.pollEndDateTime)
    ? moment().isSame(moment(formik.values.pollEndDateTime), 'day')
    : false

  const isHasAutomateCall = includes(
    CHANNEL_CALL,
    formik.values.channels.channelIds,
  )

  const isNotHasSubscriberAndNotHaveSocial =
    subscriberTotal[SUBSCRIBER_COUNT] === 0 &&
    compose(
      not,
      gt(__, 0),
      length,
      filter(
        includes(__, [
          FACEBOOK_VALUE,
          INSTAGRAM_VALUE,
          LINKEDIN_VALUE,
          TWITTER_VALUE,
        ]),
      ),
    )(formik.values.channels.channelIds)

  const isReminderDisabled =
    formik.values.notiType === TYPE_EVENT ||
    formik.values.expirationTime > 0 ||
    isPoll

  const closeOverdraft = () => {
    setIsOverDraftDialog(false)
  }

  const handleAcceptOverdraft = (formValue) => {
    closeOverdraft()
    const isUserAcceptOverdraft = true
    // Ensure body is synced from editor if undefined
    const syncedValues = {
      ...formValue,
      body: formValue.body ?? bodyEditor?.getHTML() ?? undefined,
    }
    submitNoti(syncedValues, isUserAcceptOverdraft)
  }

  const incUploadingCount = useCallback(() => {
    setUploadingCount(inc)
  }, [setUploadingCount])
  const decUploadingCount = useCallback(() => {
    setUploadingCount((prev) => {
      const newCount = prev > 0 ? prev - 1 : prev
      // Trigger validation when all uploads complete to update isValid state
      if (newCount === 0) {
        setTimeout(() => formik.validateForm(), 0)
      }
      return newCount
    })
  }, [formik])

  const openClosingDialog = useCallback(() => {
    if (
      (isBeaconDialog && formik.dirty) ||
      (isPoll && !mes_5281_save_draft_for_polls)
    ) {
      setConfirmBeaconCloseDialog(true)
    } else if (formik.dirty) {
      setIsClosingDialogWarning(true)
    } else {
      onClose(false)
    }
  }, [formik, onClose, mes_5281_save_draft_for_polls])

  const onBeaconCofirmCloseDialog = () => {
    onClose(false)
  }

  const plainBody = useMemo(() => {
    if (!formik.values.body) return undefined
    return htmlToPlainText(formik.values.body).trim()
  }, [formik.values.body])

  const getSendOptionType = (state) => {
    if (isNil(state) || isNil(state.schedule)) return TYPE_SEND_NOW
    else return TYPE_SEND_SCHEDULE
  }

  const getSubmitEditLabelId = (type) => {
    if (notification.notiType === TYPE_EVENT && isSent) return 'action.resend'
    else if (type === TYPE_SEND_NOW) return 'text.send.message'
    else return 'action.save'
  }

  const getSubmitLabelId = (value) => {
    if (isBeaconDialog) {
      return isEditMode ? 'action.save' : 'action.create'
    }
    const type = getSendOptionType(value)

    if (isEditMode) return getSubmitEditLabelId(type)

    if (type === TYPE_SEND_NOW) return 'text.send.message'
    else if (type === TYPE_SEND_SCHEDULE)
      return 'createNotification.dialog.label.schedule'
    else return 'text.send.message'
  }

  const closePreviewAndSubmit = (values) => {
    setIsOpenPreview(false)
    // Ensure body is synced from editor if undefined
    const syncedValues = {
      ...values,
      body: values.body ?? bodyEditor?.getHTML() ?? undefined,
    }
    submitNoti(syncedValues)
  }

  const getDateWithTimezone = (date, timezone) => {
    if (isNil(date)) return undefined
    return momentTimezone(date).tz(timezone).format(API_DATE_FORMATTED)
  }

  const messageValues = {
    l: (text) => (
      <PrimaryRouterLink
        to={Routes.manageChannels()}
        onClick={() => openClosingDialog()}
        className="underline"
      >
        {text}
      </PrimaryRouterLink>
    ),
  }

  const firstMount = () => {
    handleFirstMount(isBeaconDialog)
  }

  const onSwitchTypeDialog = (type) => {
    if (!formik.dirty) {
      handleSwitchDialog(type)
    }
    if (formik.dirty && type !== dialogType) {
      setIsOpenSwitchDialog(true)
    }
  }

  const handleSwitchDialog = (type) => {
    const models = formik.values
    const isBeacon = type === BEACON_DIALOG
    if (onSubmitting) {
      onSubmitting(false)
    }
    dispatch(onChangeTypeDialog(type))
    formik.resetForm()
    handleFirstMount(isBeacon)
    setTimeout(() => {
      formik.setFieldValue('mediaSocials', models.mediaSocials)
      formik.setFieldValue('recipients', { subGroups: [], subscribers: [] })
      dispatchShowMessageRatio(false)
      formik.setFieldValue('channels', { channelIds: [], pageIds: [] })
      formik.setFieldValue('title', models.title)
      formik.setFieldValue('body', models.body)
      formik.setFieldValue('voucher', models.voucher)
      formik.setFieldValue('notiType', TYPE_GENERAL)
      formik.setFieldValue('priority', models.priority)
      setIsOpenSwitchDialog(false)
      dispatch(clearInitailValue())
    }, 200)
  }

  useEffect(firstMount, [])

  // Sync all timezone fields to use the same value (unified timezone)
  // This ensures all timezones are synchronized on initial load
  useEffect(() => {
    const timezoneFields = {
      scheduleTimezone: formik.values.scheduleTimezone,
      reminderTimezone: formik.values.reminderTimezone,
      eventTimezone: formik.values.eventTimezone,
      pollTimezone: formik.values.pollTimezone,
    }

    // Find the first non-empty timezone value to use as source of truth
    const unifiedTz = first(compact(Object.values(timezoneFields)))

    if (unifiedTz) {
      // Check if any field needs syncing
      const needsSync = some(
        Object.values(timezoneFields),
        (tz) => tz !== unifiedTz,
      )

      if (needsSync) {
        // Batch update all timezone fields to avoid multiple validation cycles
        const updatedValues = { ...formik.values }
        Object.keys(timezoneFields).forEach((fieldName) => {
          if (timezoneFields[fieldName] !== unifiedTz) {
            updatedValues[fieldName] = unifiedTz
          }
        })
        formik.setValues(updatedValues, false)
      }
    }
    // Only run on mount or when timezone values actually differ
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (formik.values.mediaSocials.length > 0) {
      setImageInfo(
        map(
          (image) => ({
            path: image.url,
            name: image.name,
            isSelected: image.isSelected,
          }),
          formik.values.mediaSocials,
        ),
      )
    } else {
      setImageInfo([])
    }
  }, [formik.values.mediaSocials])

  useEffect(() => {
    if (submitErrorDetails?.code === MESSAGE_CREDIT_NOT_ENOUGH_CODE) {
      setIsOverDraftDialog(true)
    }
  }, [submitErrorDetails])

  useEffect(() => {
    if (!formik.dirty) return
    function handleOnBeforeUpload(event) {
      event.preventDefault()
      return (event.returnValue = '')
    }
    window.addEventListener('beforeunload', handleOnBeforeUpload)

    return () => {
      window.removeEventListener('beforeunload', handleOnBeforeUpload)
    }
  }, [formik.dirty])

  useEffect(() => {
    function handleClickBack(e) {
      if (!formik.dirty) {
        onClose()
        return
      }

      if (
        window.confirm(
          formatMessage({
            id: 'createNotification.dialog.confirmClose.alert.title',
          }),
        )
      ) {
        window.history.back()
        onClose()
        window.removeEventListener('popstate', handleClickBack)
      }
    }
    window.addEventListener('popstate', handleClickBack)
    return () => {
      window.removeEventListener('popstate', handleClickBack)
    }
  }, [formik.dirty, formatMessage, onClose])

  //composing message ai tour
  const [CMAITourRun, setCMAIRunTour] = useState(
    !localStorageService.getComposeAITour(),
  )
  const onSkipCMAITour = () => {
    setCMAIRunTour(false)
    localStorageService.setComposeAITour(true)
    localStorageService.setGVAAITour(true)
    generateTextWithAI.onCloseClick()
  }
  const onClickGenerateAIButton = () => {
    generateTextWithAI.onOpenClick()
  }
  const onCMAIClickFinish = () => {
    setCMAIRunTour(false)
    localStorageService.setComposeAITour(true)
    generateTextWithAI.onCloseClick()
  }
  const openGeneratingTextWithAIScreen = () => {
    generateTextWithAI.onTopicClick(0)
    generateTextWithAI.onOpenClick()
  }

  const openRefineContentScreen = () => {
    generateTextWithAI.onGenerateContentClick()
  }
  const closeGeneratingTextWithAIScreen = () => {
    generateTextWithAI.onCloseClick()
  }

  const onClickGeneratingAIIconFromTitle = (body) => {
    generateTextWithAI.onGenerateWithTextClick(body)
  }

  const onClickRateByAI = () => {
    rateWithAI.onRateClick(plainBody)
  }

  const [gvaImageTour, setGVAImageTour] = useState(false)

  const onClickFinishGVATour = () => {
    setGVAImageTour(false)
    localStorageService.setGVAAITour(true)
    generateImageWithAI.onCloseClick()
  }
  const onDismissGVATour = () => {
    setGVAImageTour(false)
    localStorageService.setGVAAITour(true)
    localStorageService.setComposeAITour(true)
    generateImageWithAI.onCloseClick()
  }
  const onClickGenerateImageAI = () => {
    if (!localStorageService.getGVAAITour()) {
      setGVAImageTour(true)
      return
    }

    generateImageWithAI.onOpenClick(
      formik.values.body
        ? htmlToPlainText(formik.values.body).trim()
        : undefined,
    )
  }

  const onClickStartTour = () => {
    localStorageService.clearTours()
    onCloseRightTab()
    setCMAIRunTour(true)
  }

  useEffect(() => {
    if (isCopyMessage) {
      formik.setFieldValue('forceChange', moment().format())
    }
  }, [isCopyMessage])

  return (
    <>
      <CMAITour
        run={CMAITourRun}
        onClickSkip={onSkipCMAITour}
        openGeneratingTextWithAIScreen={openGeneratingTextWithAIScreen}
        onClickFinish={onCMAIClickFinish}
        openRefineContentScreen={openRefineContentScreen}
        closeGeneratingTextWithAIScreen={closeGeneratingTextWithAIScreen}
      />

      <GVAImagesAITour
        run={gvaImageTour}
        onClickFinish={onClickFinishGVATour}
        onDismiss={onDismissGVATour}
        onSecondStepClickPrevious={() => {
          generateImageWithAI.onCloseClick()
        }}
      />

      <div className="h-screen overflow-hidden bg-gray-50">
        <header className="fixed inset-x-0 top-0 bg-white shadow z-50 flex items-center px-5 h-64 bg-white">
          <div className="flex w-full justify-between h-full">
            <div className="flex justify-between w-full align-middle h-full">
              <div className="flex align-middle">
                {((!isEditMode && !isDraft && isBeaconEnabled) ||
                  isCopyMessage) && (
                  <div className="px-5 flex space-x-3 m-auto">
                    <Button
                      variant="contained"
                      size="small"
                      className={clsx(
                        'h-36 capitalize text-14 font-medium shadow',
                        isBeaconDialog
                          ? 'bg-primary-lighter text-blue-950'
                          : 'bg-secondary text-primary-light',
                      )}
                      onClick={() => onSwitchTypeDialog(GENERAL_DIALOG)}
                    >
                      <FormattedMessage
                        id={
                          isDownXs
                            ? 'navigation.notifications.create.label'
                            : 'action.compose.message'
                        }
                      />
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      className={clsx(
                        'h-36 capitalize w-full text-14 font-medium shadow flex-1',
                        isBeaconDialog
                          ? 'bg-secondary text-primary-light'
                          : 'bg-primary-lighter text-blue-950',
                      )}
                      onClick={() => onSwitchTypeDialog(BEACON_DIALOG)}
                    >
                      <FormattedMessage
                        id={
                          isDownXs
                            ? 'channel.beacon'
                            : 'beaconNotification.add.action'
                        }
                      />
                    </Button>
                  </div>
                )}
              </div>
              <div className="flex align-middle justify-between space-x-5">
                <div className="flex m-auto">
                  <IconButton className="p-4" onClick={toggleSettingTab}>
                    <SettingsOutlinedIcon
                      fontSize="default"
                      style={{ color: '#A8A8A8' }}
                    />
                  </IconButton>
                </div>
                <div className="flex m-auto">
                  <IconButton className="p-4" onClick={toggleHelpTab}>
                    <HelpOutlineOutlinedIcon
                      fontSize="default"
                      style={{ color: '#A8A8A8' }}
                    />
                  </IconButton>
                </div>

                {Boolean(place.enabledAi) && requestId && !isPoll && (
                  <div className="flex justify-center px-4">
                    <GenerateWithAIButton
                      className={`h-32 w-32 ${TOUR_CM_AI}`}
                      onClick={onClickGenerateAIButton}
                    />
                  </div>
                )}
                <IconButton
                  aria-label="icon button close send a message"
                  className="text-md rounded-none"
                  onClick={openClosingDialog}
                >
                  <Icon className="text-26 text-blue-950">close</Icon>
                </IconButton>
              </div>
            </div>
          </div>
        </header>
        <main className="mt-64 mb-64 h-[calc(100vh-64px-64px)]">
          <div className="flex h-full gap-4 bg-primary-100 p-10 space-x-5">
            <div className="flex-1 min-w-0 overflow-y-auto rounded-8 pr-5">
              <div>
                {isBeaconDialog && (
                  <>
                    <div className="mb-5 w-full">
                      <div className="flex text-14 font-medium text-blue-950 margin-auto mb-4">
                        <FormattedMessage id="beaconSelector.label.beacons" />
                        <label className="px-2">*</label>
                      </div>
                      <BeaconSelector
                        name="beacons"
                        options={beacons}
                        isLoading={isLoading}
                        fetchData={fetchBeacons}
                      />
                    </div>
                    <div className="mb-5 w-full">
                      <div className="w-fit flex text-14 font-medium text-blue-950 mb-4">
                        <FormattedMessage id="compose.message.proximity.distance.label" />
                        <label className="px-2">*</label>
                        <PrimaryTooltip
                          title={formatMessage({
                            id: 'composeMessage.dialog.proximity.tooltip.text',
                          })}
                        >
                          <div>
                            <InfoOutlinedIcon fontSize="small" />
                          </div>
                        </PrimaryTooltip>
                      </div>
                      <div className="bg-white rounded-8 border border-grey-input text-blue-950 p-5">
                        <div className="sm:flex sm:space-x-5 space-y-5 sm:space-y-0">
                          <div className="sm:flex-1">
                            <SelectorFormik
                              label={formatMessage({
                                id: 'compose.message.room.size.label',
                              })}
                              name="roomSize"
                              options={getRangeOptions(
                                formik.values.proximityLength,
                                formatMessage,
                              )}
                              onChange={onRoomSizeChange}
                              placeholder={formatMessage({
                                id: 'compose.message.room.size.placeholder',
                              })}
                            />
                          </div>
                          <div className="sm:w-4/12 min-w-64">
                            <SelectorFormik
                              label={formatMessage({
                                id: 'compose.message.proximity.length.label',
                              })}
                              name="proximityLength"
                              options={proximityLengthOptions}
                              placeholder={formatMessage({
                                id: 'compose.message.proximity.length.placeholder',
                              })}
                            />
                          </div>
                        </div>
                        <div>
                          <BeaconRange
                            name="range"
                            onChange={onRangeChange}
                            unit={getUnitShortName(
                              formik.values.proximityLength,
                              formatMessage,
                            )}
                            inputprops={{ 'data-testid': 'range' }}
                          />
                        </div>
                        <div>
                          <label>
                            <FormattedMessage
                              id="compose.message.warning,range.label"
                              values={{
                                range: formik.values.range,
                                unit: toLower(
                                  getUnitText(
                                    formik.values.proximityLength,
                                    formatMessage,
                                  ),
                                ),
                              }}
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <div className="mb-5 w-full">
                  <div className="flex text-14 font-medium text-blue-950 margin-auto  mb-4">
                    <FormattedMessage id="label.recipients" />
                    {isEmpty(formik.values.channels.pageIds) && (
                      <label className="px-2">*</label>
                    )}
                    {isShowMessageRatioMessage ? (
                      <div
                        onClick={openCreditDialog}
                        className="ml-auto font-normal cursor-pointer flex items-end gap-2"
                      >
                        <QuestionIcon
                          color="#000000"
                          classes="w-12"
                          style={{ paddingTop: '2px' }}
                        />
                        <div className="text-12">
                          {formatMessage({
                            id: 'createNotification.dialog.label.messageCreditQuestion',
                          })}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>

                  <RecipientsSelector
                    value={formik.values.recipients}
                    label={formatMessage({
                      id: 'compose.dialog.recipients.placeholder',
                    })}
                    onChange={(value) => {
                      formik.setFieldValue('recipients', value)
                      onRecipientChange(value)
                    }}
                    valueFromAnotherPage={valueFromAnotherPage}
                    isBeacon={isBeaconDialog}
                    isLoadingCount={isLoadingSubscriberTotal}
                    error={
                      !isNil(formik.getFieldMeta('recipients').error) &&
                      formik.getFieldMeta('recipients').touched
                    }
                    helperText={formik.getFieldMeta('recipients').error}
                  />
                </div>
                <div className="mb-5 w-full">
                  <div className="w-fit flex text-14 font-medium text-blue-950 mb-4">
                    <FormattedMessage id="compose.dialog.channels.label" />
                    <label className="px-2">*</label>
                  </div>
                  <ChannelSelector
                    id="channels"
                    name="channels"
                    label={formatMessage({
                      id: 'compose.dialog.channels.placeholder',
                    })}
                    channelSetting={channelSetting}
                    isLoadingCount={isLoadingSubscriberTotal}
                    onChange={onChannelsChange}
                    onChannelLoading={setChannelLoading}
                    isBeaconDialog={isBeaconDialog}
                  />
                </div>
                <div className="mb-5 w-full">
                  <Loader
                    isLoading={
                      !isEmpty(formik.values.recipients) &&
                      isLoadingSubscriberTotal
                    }
                    placeholder={
                      <FuseAnimate
                        enter={{ animation: 'fadeIn' }}
                        leave={{ animation: 'fadeOut' }}
                      >
                        <CircularProgress
                          className="mt-5"
                          color="secondary"
                          size={12}
                        />
                      </FuseAnimate>
                    }
                  >
                    {(!isEmpty(formik.values.channels.channelIds) ||
                      !isEmpty(formik.values.channels.pageIds)) &&
                      !isLoadingSubscriberTotal &&
                      !isSocialChannelOnly && (
                        <div className="flex w-full text-grey-neutral mt-3">
                          <InfoOutlinedIcon fontSize="small" className="mx-3" />
                          <div>
                            <div className="flex">
                              <SubscriberCount
                                name="subscribersCount"
                                subscriberCountState={subscriberTotal}
                                isAutomateCall={isHasAutomateCall && isAdmin}
                                messageValues={messageValues}
                              />
                            </div>
                            {!isEmpty(formik.values.topics) && (
                              <Typography className="font-bold">
                                <FormattedMessage id="createNotification.dialog.info.reach.message" />
                              </Typography>
                            )}
                          </div>
                        </div>
                      )}
                  </Loader>
                </div>
                <div className="mb-5 w-full">
                  {!place.info.shortName &&
                    includes(
                      CHANNEL_SMS,
                      formik.values.channels.channelIds,
                    ) && (
                      <ShotNameInput
                        name="shortName"
                        maxLenght={MAX_PLACE_NAME_FOR_SMS}
                      />
                    )}
                </div>
                <div className={clsx(isPoll ? 'block' : 'hidden')}>
                  <div className="mb-5 w-full">
                    <div className="w-fit flex text-14 font-medium text-blue-950 mb-2">
                      <FormattedMessage id="createNotification.dialog.poll.question.label" />
                      <label className="px-2">*</label>
                    </div>
                    <SimpleInput
                      id="question"
                      name="question"
                      type="text"
                      value={formik.values.question}
                      className="h-48 w-full mb-1 sm:mb-0 bg-white rounded-8 text-blue-950"
                      onChange={(event) => {
                        formik.setFieldValue('question', event.target.value)
                      }}
                      placeholder={formatMessage({
                        id: 'createNotification.dialog.poll.question.placeholder',
                      })}
                      maxLength={200}
                      error={
                        !isNil(formik.getFieldMeta('question').error) &&
                        formik.getFieldMeta('question').touched
                      }
                      helperText={formik.getFieldMeta('question').error}
                    />
                  </div>
                  <div className="mb-5 w-full">
                    <div className="w-fit flex text-14 font-medium text-blue-950 mb-2">
                      <FormattedMessage id="createNotification.dialog.options.title" />
                      <label className="px-2">*</label>
                    </div>
                    <DynamicTextInput
                      name="options"
                      onChange={(newValues) =>
                        formik.setFieldValue('options', newValues)
                      }
                    />
                  </div>
                  <div className="mb-5 w-full">
                    <div className="sm:flex sm:space-x-5 sm:space-y-0 space-y-5">
                      <div className="w-full">
                        <DateTimeFormik
                          className="w-full"
                          required
                          isShowLabel={true}
                          name="pollEndDateTime"
                          dateLabel={formatMessage({
                            id: 'createNotification.dialog.event.endDate',
                          })}
                          timeLabel={formatMessage({
                            id: 'createNotification.dialog.event.endTime',
                          })}
                          minDate={getDateWithTimezone(
                            minEndPoll,
                            formik.values.pollTimezone,
                          )}
                          maxDate={getDateWithTimezone(
                            maxEndPoll,
                            formik.values.pollTimezone,
                          )}
                          timezone={formik.values.pollTimezone}
                          onChange={onPollEndChange}
                          inputProps={{
                            'data-testid': `pollEndDateTime`,
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <div className="w-fit flex space-x-4 text-14 font-medium text-blue-950 mb-4">
                          <div>
                            <FormattedMessage id="createNotification.dialog.timezone.selector" />
                          </div>
                          <div>*</div>
                        </div>
                        <TimezoneFormik
                          className={clsx('w-full', classStyle.timezone)}
                          name="pollTimezone"
                          label={formatMessage({
                            id: 'createNotification.dialog.timezone.selector',
                          })}
                          inputProps={{
                            'data-testid': `pollTimezone`,
                          }}
                          variant="outlined"
                          onChange={onScheduleTimezoneChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-5 w-full">
                    <div className="w-fit flex text-14 font-medium text-blue-950  mb-4">
                      <FormattedMessage id="composeDialog.poll.additionalContext" />
                    </div>
                    <SimpleInput
                      id="additionalContext"
                      name="additionalContext"
                      value={formik.values.additionalContext}
                      type="text"
                      className="h-48 w-full mb-1 sm:mb-0 bg-white rounded-8 text-blue-950"
                      placeholder={formatMessage({
                        id: 'composeDialog.poll.additionalContext',
                      })}
                      onChange={(event) => {
                        formik.setFieldValue(
                          'additionalContext',
                          event.target.value,
                        )
                      }}
                    />
                  </div>
                </div>
                <div className={clsx(isPoll ? 'hidden' : 'block')}>
                  <div className="mb-5 w-full">
                    <div className="w-fit flex text-14 font-medium text-blue-950 mb-4">
                      <FormattedMessage
                        id={
                          formik.values.notiType === TYPE_EVENT
                            ? 'createNotification.dialog.event.title.label'
                            : 'createNotification.dialog.title.label'
                        }
                      />
                      <label className="px-2">*</label>
                    </div>
                    <DoNotTranslateEditorFormik
                      name="title"
                      placeholder={formatMessage({
                        id:
                          formik.values.notiType === TYPE_EVENT
                            ? 'createNotification.dialog.event.title.label'
                            : 'createNotification.dialog.title.label',
                      })}
                      maxLength={TITLE_MAX_LENGTH}
                      isControlsInline={true}
                      controls={TEXT_EDITOR_CONTROLS}
                      isNoRichFormat
                      scrollableContainer={scrollableContainerSelector}
                      isAIEnabled={Boolean(place.enabledAi) && requestId}
                      aiGenerateTextUpdated={aiGenerateTextUpdated}
                      onGenerateContentWithAIClick={
                        onClickGeneratingAIIconFromTitle
                      }
                    />
                  </div>
                  <div className="mb-5 w-full">
                    <div className="w-fit flex text-14 font-medium text-blue-950 mb-4">
                      <FormattedMessage
                        id={'createNotification.dialog.body.label'}
                      />
                      <label className="px-2">*</label>
                    </div>

                    <TiptapEditor
                      name="body"
                      placeholder={formatMessage({
                        id: 'createNotification.title.placeholder',
                      })}
                      value={denormalizeEmptyParagraphs(formik.values.body)}
                      maxLength={10000}
                      onUploading={incUploadingCount}
                      onUploaded={decUploadingCount}
                      onChangeImage={
                        !mes_4367_attachment_gallery
                          ? hancleImageChange
                          : undefined
                      }
                      onBodyImageAdded={
                        mes_4367_attachment_gallery
                          ? handleBodyImageAdded
                          : undefined
                      }
                      onBodyImageRemoved={
                        mes_4367_attachment_gallery
                          ? handleBodyImageRemoved
                          : undefined
                      }
                      className="mb-4"
                      error={formik.touched.body && formik.errors.body}
                      errorText={formik.errors.body}
                      onEditorReady={setBodyEditor}
                      onFocus={() => {
                        formik.setFieldTouched('body', true, false)
                      }}
                      onChange={(content) => {
                        formik.setFieldValue('body', content, false)
                      }}
                      onError={() => {
                        formik.setFieldError('body', undefined)
                      }}
                      toolbarItems={
                        <div className="flex items-center mx-4 px-4 py-4 sm:space-y-0 space-y-4 space-x-5">
                          {Boolean(place.enabledAi) && requestId && (
                            <button
                              aria-label="Generate an image with AI cursor-pointer"
                              onClick={onClickGenerateImageAI}
                              className={clsx(
                                'flex w-196 border px-2 py-1 border-secondary items-center rounded rounded-8 text-gray-600 hover:bg-gray-100 hover:text-primary',
                                GVA_IMAGE_AI_FIRST_STEP_TOUR,
                              )}
                              type="button"
                            >
                              <ImageAiIcon classes="w-24 h-24" />
                              <label className="w-full p-4 text-12 text-secondary cursor-pointer">
                                <FormattedMessage id="ai.generate.image.label" />
                              </label>
                            </button>
                          )}
                          {(gvaImageTour ||
                            (plainBody &&
                              plainBody.length > 0 &&
                              !rateWithAI.doNotShowAgain &&
                              Boolean(place.enabledAi) &&
                              requestId)) && (
                            <button
                              aria-label="rate by AI"
                              onClick={onClickRateByAI}
                              className={`flex w-196 border px-2 py-1 border-secondary cursor-pointer items-center rounded rounded-8 text-gray-600 my-5 hover:bg-gray-100 hover:text-primary ${TOUR_RATE_ENHANCE}`}
                              type="button"
                            >
                              <RateAiIcon classes="w-24 h-24" />
                              <label className="w-full p-4 text-12 text-secondary cursor-pointer">
                                <FormattedMessage id="ai.rateAndEnhance.image.label" />
                              </label>
                            </button>
                          )}
                        </div>
                      }
                    />
                  </div>
                </div>

                <div className="mb-5 w-full">
                  {!mes_4367_attachment_gallery ? (
                    <>
                      <div className="w-fit flex text-14 font-medium text-blue-950 mb-4">
                        <span className="flex justify-between space-x-2 align-middle">
                          <label>
                            <FormattedMessage id="compose.dialog.thumbnail.images.label" />
                          </label>
                          {includes(
                            INSTAGRAM_VALUE,
                            formik.values.channels.channelIds,
                          ) && <div>*</div>}
                          <PrimaryTooltip
                            title={formatMessage({
                              id: 'createNotification.dialog.title.selector.image.footer',
                            })}
                          >
                            <div>
                              <InfoOutlinedIcon fontSize="small" />
                            </div>
                          </PrimaryTooltip>
                        </span>
                      </div>
                      <SocialMediaSetting
                        name="mediaSocials"
                        required
                        socialIcon={Assets.gallery}
                        title={formatMessage({
                          id: 'compose.dialog.thumbnail.images.label',
                        })}
                      />
                    </>
                  ) : (
                    <Attachments
                      formik={formik}
                      images={imageInfo}
                      onLoadingStateChange={setIsAttachmentsLoading}
                      onSyncedImageDelete={handleSyncedImageDelete}
                      onDeleteAll={handleDeleteAllAttachments}
                    />
                  )}
                </div>
                {formik.values.notiType === TYPE_EVENT && (
                  <>
                    <div className="mb-5 w-full">
                      <div className="w-fit flex space-x-4 text-14 font-medium text-blue-950 mb-4">
                        <div>
                          <FormattedMessage id="createNotification.dialog.event.location" />
                        </div>
                        <div>*</div>
                      </div>
                      <PlacesAddressAutocompleteFormik
                        name="location"
                        labelId="createNotification.dialog.event.location"
                        placeholderId="createNotification.location.placeholder"
                        parseValue={prop('description')}
                        clearBtn
                        required
                        classes={classStyle}
                        isMapLoaded={formik.values.notiType === TYPE_EVENT}
                      />
                    </div>
                    <div className="mb-5 w-full">
                      <div className="mb-2 sm:flex sm:space-x-5 sm:space-y-0 space-y-5">
                        <DateTimeFormik
                          className="w-full"
                          required
                          isShowLabel={true}
                          name="eventStartDateTime"
                          dateLabel={formatMessage({
                            id: 'createNotification.dialog.event.startDate',
                          })}
                          timeLabel={formatMessage({
                            id: 'createNotification.dialog.event.startTime',
                          })}
                          timezone={formik.values.eventTimezone}
                          minDate={getDateWithTimezone(
                            minStartEvent,
                            formik.values.eventTimezone,
                          )}
                          maxDate={getDateWithTimezone(
                            maxStartEvent,
                            formik.values.eventTimezone,
                          )}
                          onChange={onEventStartDateChange}
                          disabled={isEventStartDatedisabled}
                          inputProps={{
                            'data-testid': `eventStartDateTime`,
                          }}
                        />
                        <div className="sm:block hidden">
                          <div className="flex items-center pt-5 h-full">
                            To
                          </div>
                        </div>
                        <DateTimeFormik
                          className="w-full"
                          required={false}
                          isShowLabel={true}
                          name="eventEndDateTime"
                          disabled={isNil(formik.values.eventStartDateTime)}
                          dateLabel={formatMessage({
                            id: 'createNotification.dialog.event.endDate',
                          })}
                          timeLabel={formatMessage({
                            id: 'createNotification.dialog.event.endTime',
                          })}
                          timezone={formik.values.eventTimezone}
                          minDate={getDateWithTimezone(
                            minEndEvent,
                            formik.values.eventTimezone,
                          )}
                          maxDate={getDateWithTimezone(
                            maxEndEvent,
                            formik.values.eventTimezone,
                          )}
                          inputProps={{
                            'data-testid': `eventEndDateTime`,
                          }}
                        />
                      </div>
                    </div>
                    <div className="mb-10 w-full">
                      <div className="w-fit flex space-x-4 text-14 font-medium text-blue-950 mb-4">
                        <div>
                          <FormattedMessage id="createNotification.dialog.timezone.selector" />
                        </div>
                        <div>*</div>
                      </div>
                      <TimezoneFormik
                        className={clsx('w-full', classStyle.timezone)}
                        name="eventTimezone"
                        label={formatMessage({
                          id: 'createNotification.dialog.timezone.selector',
                        })}
                        inputProps={{
                          'data-testid': `eventTimezone`,
                        }}
                        variant="outlined"
                        onChange={onScheduleTimezoneChange}
                      />
                    </div>
                  </>
                )}

                <div className="mb-5 w-full pb-5">
                  <CollapsePanelV2
                    title={
                      <MoreOptionTitle
                        isBeacon={isBeaconDialog}
                        values={formik.values}
                      />
                    }
                  >
                    <div className="sm:flex sm:space-x-5 w-full">
                      <div className="mb-5 w-full">
                        <div className="w-fit flex text-14 text-blue-950 mb-4 font-medium">
                          <FormattedMessage id="createNotification.dialog.notiType" />
                          <div className="mx-2">{'*'}</div>
                        </div>
                        <MessageTypeSelector
                          name="notiType"
                          required
                          variant="outlined"
                          disabled={isCopyMessage ? false : isSent && !isDraft}
                          isBeacon={isBeaconDialog}
                          inputProps={{
                            'data-testid': 'messageTypeSelector',
                          }}
                          className={clsx(classStyle.root, 'bg-white')}
                          onChange={onNotificationTypeChange}
                          isDraft={isDraft}
                          isSchedule={equals(
                            formik.values.sendOptions,
                            TYPE_SEND_SCHEDULE,
                          )}
                          isPoll={isPoll}
                          isEditMode={isEditMode}
                        />
                      </div>
                      <div className="mb-5 w-full">
                        <div className="w-fit flex text-14 text-blue-950  font-medium mb-4">
                          <FormattedMessage id="createNotification.dialog.notiPriority" />
                          <div className="ml-2">{'*'}</div>
                        </div>
                        <MessagePrioritySelector
                          name="priority"
                          required
                          inputProps={{
                            'data-testid': 'messagePrioritySelector',
                          }}
                          className={clsx(
                            classStyle.root,
                            'bg-white rounded-8 border-0 shadow-xs',
                          )}
                          isEmergency={path(
                            ['info', 'category', 'allowEmergency'],
                            place,
                          )}
                        />
                      </div>
                      {!isBeaconDialog && (
                        <div className="mb-5 w-full">
                          <div className="w-fit flex text-14 text-blue-950  font-medium mb-4">
                            <FormattedMessage id="createNotification.dialog.expiration" />
                          </div>
                          <MessageExpirationSelector
                            name="expirationTime"
                            required
                            inputProps={{
                              'data-testid': 'messageExpirationSelector',
                            }}
                            className={clsx(
                              classStyle.root,
                              'bg-white rounded-8 border-0 shadow-xs',
                            )}
                            onChange={onExpirationChange}
                          />
                        </div>
                      )}
                    </div>
                    {!isBeaconDialog && (
                      <div className="mb-5 w-full">
                        <div className="w-fit flex text-14 font-medium text-blue-950 mb-4">
                          <FormattedMessage id="notifications.topics.label" />
                        </div>
                        <TopicSelector
                          id="topics"
                          name="topics"
                          label={formatMessage({
                            id: 'createNotification.dialog.select.topic.label',
                          })}
                          options={topicsOptions}
                          groupBy={formatMessage({
                            id: 'createNotification.topic.selecbox.label',
                          })}
                          isLoading={isLoadingTopics}
                          onChange={onTopicsChange}
                        />
                      </div>
                    )}
                    {!isPoll && (
                      <div className="mb-5 w-full">
                        <div className="w-fit flex text-14 font-medium text-blue-950 mb-4">
                          <FormattedMessage id="dealsPromoation.attach.select.label" />
                        </div>
                        <AttachVoucherSelector
                          name="voucher"
                          label={formatMessage({
                            id: 'dealsPromoation.attach.select.label',
                          })}
                          options={vouchersOptions}
                          fetchVouchers={fetchVouchers}
                          onChange={(voucherId) => {
                            if (formik.values.notiType === TYPE_EVENT) {
                              const voucher = find(
                                propEq('id', voucherId),
                                vouchersOptions,
                              )
                              onVoucherChange(voucher)
                            }
                          }}
                        />
                      </div>
                    )}
                    <div className="mb-5 w-full">
                      <div className="w-fit flex text-14 font-medium text-blue-950 mb-4">
                        <FormattedMessage
                          id={
                            isBeaconDialog
                              ? 'createNotificationBeacon.dialog.runningTime.label'
                              : 'createNotification.more.option.schedule.label'
                          }
                        />
                      </div>
                      <div className="bg-white rounded-8 border border-grey-input text-blue-950 pb-5">
                        <div>
                          <div className="w-full p-5">
                            <MessageOptionFormik
                              name="sendOptions"
                              className="w-1/3"
                              isSendNowDisabled={
                                isEditMode &&
                                equals(
                                  formik.values.sendOptions,
                                  TYPE_SEND_SCHEDULE,
                                )
                              }
                              isScheduleDisabled={
                                (isEditMode &&
                                  equals(
                                    formik.values.sendOptions,
                                    TYPE_SEND_NOW,
                                  )) ||
                                isScheduleDisabled ||
                                isEndpPollToDay
                              }
                              onChange={onMessageOptionChange}
                            />
                            {equals(
                              formik.values.sendOptions,
                              TYPE_SEND_SCHEDULE,
                            ) &&
                              (isBeaconDialog ? (
                                <>
                                  <div className="mb-5 w-full">
                                    <div className="mb-2 sm:flex sm:space-x-5 sm:space-y-0 space-y-5">
                                      <DateTimeFormik
                                        className="w-full"
                                        required
                                        isShowLabel={true}
                                        name="scheduleStartDate"
                                        dateLabel={formatMessage({
                                          id: 'createNotification.dialog.event.startDate',
                                        })}
                                        timeLabel={formatMessage({
                                          id: 'createNotification.dialog.event.startTime',
                                        })}
                                        timezone={
                                          formik.values.scheduleBeaconTimezone
                                        }
                                        minDate={getDateWithTimezone(
                                          minStartScheduleBeacon,
                                          formik.values.scheduleBeaconTimezone,
                                        )}
                                        maxDate={getDateWithTimezone(
                                          maxStartScheduleBeacon,
                                          formik.values.scheduleBeaconTimezone,
                                        )}
                                        onChange={onScheduleStartDateChange}
                                        disabled={isEventStartDatedisabled}
                                        inputProps={{
                                          'data-testid': `scheduleStartDate`,
                                        }}
                                      />
                                      <div className="sm:block hidden">
                                        <div className="flex items-center pt-5 h-full">
                                          To
                                        </div>
                                      </div>
                                      <DateTimeFormik
                                        className="w-full"
                                        required
                                        isShowLabel={true}
                                        name="scheduleEndDate"
                                        disabled={not(
                                          formik.values.addEndDateSchedule,
                                        )}
                                        dateLabel={formatMessage({
                                          id: 'createNotification.dialog.event.endDate',
                                        })}
                                        timeLabel={formatMessage({
                                          id: 'createNotification.dialog.event.endTime',
                                        })}
                                        timezone={
                                          formik.values.scheduleBeaconTimezone
                                        }
                                        minDate={getDateWithTimezone(
                                          minEndScheduleBeacon,
                                          formik.values.scheduleBeaconTimezone,
                                        )}
                                        maxDate={getDateWithTimezone(
                                          maxEndScheduleBeacon,
                                          formik.values.scheduleBeaconTimezone,
                                        )}
                                        inputProps={{
                                          'data-testid': `scheduleEndDate`,
                                        }}
                                        onChange={onScheduleEndDateChange}
                                      />
                                    </div>
                                    <div className="w-full flex space-x-1">
                                      <CheckBox
                                        onChange={onAddEndDateSchedule}
                                        name="addEndDateSchedule"
                                        checked={
                                          formik.values.addEndDateSchedule
                                        }
                                        inputProps={{
                                          'data-testid': `addEndDateSchedule`,
                                        }}
                                      />
                                      <Typography className="m-auto">
                                        <FormattedMessage id="composeMessage.dialog.addEndDateSchedule.label" />
                                      </Typography>
                                    </div>
                                  </div>
                                  <div className="mb-5 w-full">
                                    <div className="w-fit flex text-14 font-medium text-blue-950 mb-4">
                                      <FormattedMessage id="createNotification.dialog.timezone.selector" />
                                    </div>
                                    <TimezoneFormik
                                      className={clsx(
                                        'w-full',
                                        classStyle.timezone,
                                      )}
                                      name="scheduleBeaconTimezone"
                                      label={formatMessage({
                                        id: 'createNotification.dialog.timezone.selector',
                                      })}
                                      inputProps={{
                                        'data-testid': `scheduleBeaconTimezone`,
                                      }}
                                      variant="outlined"
                                      onChange={onScheduleBeaconTimezoneChange}
                                    />
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="flex space-x-5 px-3">
                                    <div className="w-full">
                                      <DateTimeFormik
                                        className="w-full"
                                        required
                                        isShowLabel={true}
                                        name="schedule"
                                        dateLabel={formatMessage({
                                          id: 'createNotification.dialog.schedule.date.label',
                                        })}
                                        timeLabel={formatMessage({
                                          id: 'createNotification.dialog.schedule.time.label',
                                        })}
                                        minDate={getDateWithTimezone(
                                          minSchedule,
                                          formik.values.scheduleTimezone,
                                        )}
                                        maxDate={getDateWithTimezone(
                                          maxSchedule,
                                          formik.values.scheduleTimezone,
                                        )}
                                        disabled={
                                          isScheduleDisabled ||
                                          isEventStartDatedisabled ||
                                          isEndpPollToDay
                                        }
                                        timezone={
                                          formik.values.scheduleTimezone
                                        }
                                        onChange={onScheduleChange}
                                        inputProps={{
                                          'data-testid': `schedule`,
                                        }}
                                      />
                                    </div>
                                    <div className="w-full">
                                      <div className="w-fit flex text-14 text-blue-950 mb-4">
                                        <FormattedMessage id="createNotification.dialog.timezone.selector" />
                                      </div>
                                      <TimezoneFormik
                                        className={clsx(
                                          'w-full',
                                          classStyle.timezone,
                                        )}
                                        disabled={isScheduleDisabled}
                                        name="scheduleTimezone"
                                        label={formatMessage({
                                          id: 'createNotification.dialog.timezone.selector',
                                        })}
                                        inputProps={{
                                          'data-testid': `scheduleTimezone`,
                                        }}
                                        onChange={onScheduleTimezoneChange}
                                        variant="outlined"
                                      />
                                    </div>
                                  </div>
                                </>
                              ))}
                          </div>
                          {isBeaconDialog && (
                            <>
                              <Divider className="my-2 w-full" />
                              <div className="w-full p-5 px-10">
                                <div className="text-blue-950 space-y-4 mb-5">
                                  <label className="font-bold text-14">
                                    <FormattedMessage id="createNotification.message.recurrence.label" />
                                  </label>
                                  <div className="text-grey-100 text-14">
                                    <FormattedMessage id="createNotification.message.recurrence.subLabel" />
                                  </div>
                                </div>
                                <FrequencyTypeSelector
                                  value={formik.values.frequencyType}
                                />
                              </div>
                            </>
                          )}
                        </div>
                        {!isBeaconDialog && (
                          <div className="w-full px-5">
                            <Divider className="my-2 w-full" />
                            <div className="flex space-x-2">
                              <CheckBox
                                onChange={onCheckedReminder}
                                disabled={isReminderDisabled}
                                name="reminderChecked"
                                checked={formik.values.reminderChecked}
                                inputProps={{
                                  'data-testid': `reminderChecked`,
                                }}
                              />
                              <Typography
                                className={clsx(
                                  'm-auto',
                                  isReminderDisabled && 'opacity-50',
                                )}
                              >
                                <FormattedMessage id="createNotification.dialog.label.reminder" />
                              </Typography>
                            </div>

                            {formik.values.reminderChecked && (
                              <>
                                <div className="flex space-x-5 px-3">
                                  <div className="w-full">
                                    <DateTimeFormik
                                      className="w-full"
                                      required
                                      isShowLabel={true}
                                      name="reminder"
                                      dateLabel={formatMessage({
                                        id: 'createNotification.dialog.reminder.date.label',
                                      })}
                                      timeLabel={formatMessage({
                                        id: 'createNotification.dialog.reminder.time.label',
                                      })}
                                      minDate={getDateWithTimezone(
                                        minReminder,
                                        formik.values.reminderTimezone,
                                      )}
                                      maxDate={getDateWithTimezone(
                                        maxReminder,
                                        formik.values.reminderTimezone,
                                      )}
                                      timezone={formik.values.reminderTimezone}
                                      inputProps={{
                                        'data-testid': `reminder`,
                                      }}
                                    />
                                  </div>
                                  <div className="w-full">
                                    <div className="w-fit flex text-14 text-blue-950 mb-4">
                                      <FormattedMessage id="createNotification.dialog.timezone.selector" />
                                    </div>
                                    <TimezoneFormik
                                      className={clsx(
                                        'w-full',
                                        classStyle.timezone,
                                      )}
                                      name="reminderTimezone"
                                      label={formatMessage({
                                        id: 'createNotification.dialog.timezone.selector',
                                      })}
                                      inputProps={{
                                        'data-testid': `reminderTimezone`,
                                      }}
                                      onChange={onScheduleTimezoneChange}
                                      variant="outlined"
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </CollapsePanelV2>
                </div>
              </div>
            </div>

            <div className="w-4/12 min-w-0 overflow-y-auto rounded-lg hidden lg:block">
              <div>
                {mes_2175_new_live_preview ? (
                  <PreviewMessageV4
                    notification={mapToPreview(place, formik.values)}
                  />
                ) : (
                  <PreviewMessage
                    notification={mapToPreview(place, formik.values)}
                  />
                )}
              </div>
            </div>
          </div>
        </main>

        <footer
          ref={footerRef}
          className="fixed inset-x-0 bottom-0 h-64 bg-white shadow z-50 px-4 border-t-1 border-gray-200 sm:flex items-center sm:justify-end "
        >
          {isBeaconDialog && (
            <div className="flex space-x-5 px-5 justify-end">
              <div className="sm:m-auto">
                <IosSwitchFormik
                  name="isBeaconEnabled"
                  inputProps={{
                    'data-testid': `isBeaconEnabled`,
                  }}
                />
              </div>
              <Typography className="text-14 text-blue-950">
                <FormattedMessage id="createNotificationBeacon.dialog.active.notification.label" />
              </Typography>
            </div>
          )}
          <ResponsiveDialogAction
            className="p-0 px-5"
            StartBtnStyles="w-full sm:w-auto"
            EndBtnStyles="w-full sm:w-auto"
            StartButton={
              <SecondaryButton
                className="w-full block lg:hidden shadow-xs"
                disabled={
                  (isEditMode || isDraft) &&
                  formik.isValid &&
                  !mes_3198_poll_preview_translation &&
                  !isPoll
                    ? false
                    : !formik.dirty ||
                      !formik.isValid ||
                      formik.isSubmitting ||
                      isUploadingFiles ||
                      isNotHasSubscriberAndNotHaveSocial
                }
                labelId="createNotification.dialog.preview"
                onClick={() => setIsOpenPreview(true)}
              />
            }
            EndButton={
              <ContainedButton
                id="submit-compose-btn"
                color={SECONDARY}
                className="w-full"
                isLoading={isLoadingButtonSubmit}
                onClick={() => {
                  if (onSubmitting) {
                    onSubmitting()
                  }
                  formik.validateForm().then((res) => {
                    formik.submitForm()
                  })
                }}
                disabled={isButtonDisabled}
                type="submit"
              >
                <div className="flex">
                  <span>
                    {formatMessage({
                      id: getSubmitLabelId(formik.values),
                    })}
                  </span>
                </div>
              </ContainedButton>
            }
          />
        </footer>
      </div>

      {(isShowHelpTab || isShowSettingTab) && (
        <div className="fixed w-full right-0 top-0 bottom-0 z-999 h-screen">
          <div className="flex">
            <div
              onClick={onCloseRightTab}
              className={clsx(
                'flex-1 inset-0 bg-black bg-opacity-50 transition-opacity',
                isShowHelpTab || isShowSettingTab
                  ? 'hidden sm:block'
                  : 'hidden',
              )}
            ></div>
            <ComposeRightTab
              isShowHelpTab={isShowHelpTab}
              isShowSettingTab={isShowSettingTab}
              onCloseRightTab={onCloseRightTab}
              onHandleTtsdisabled={onHandleTtsdisabled}
              onSharingEnabledChange={onSharingEnabledChange}
              isSharingEnabled={formik.values.isSharingEnabled}
              isBeaconDialog={isBeaconDialog}
              onClickStartTour={onClickStartTour}
              isEditMode={isEditMode}
              isPoll={isPoll}
            />
          </div>
        </div>
      )}

      {isOpenPreview && (
        <TranslationPreview
          recipients={formik.values.recipients}
          topics={formik.values.topics}
          pages={formik.values.recipients.subscribers}
          channels={formik.values.channels.channelIds}
          subscriberCount={subscriberTotal[SUBSCRIBER_COUNT]}
          open={isOpenPreview}
          onClose={() => setIsOpenPreview(false)}
          notification={mapToPreview(place, formik.values)}
          onClickSendNow={() => {
            closePreviewAndSubmit(formik.values)
          }}
          submitLabelId={getSubmitLabelId(formik.values)}
          isSubmitButtonDisabled={
            isDraft && formik.isValid
              ? false
              : !formik.dirty || !formik.isValid || isSubmitting
          }
        />
      )}

      {isOverDraftDialog && (
        <CreateNotificationOverdraftDialog
          isOpen={isOverDraftDialog}
          onClose={closeOverdraft}
          onAcceptOverdraft={handleAcceptOverdraft}
          submitErrorDetails={submitErrorDetails}
          formValue={formik.values}
        />
      )}
      <DraftNotificationPopup
        open={isClosingDialogWarning}
        handleCloseDialog={() => setIsClosingDialogWarning(false)}
        title={formatMessage({
          id: isNotSaveDraft
            ? 'draft.notification.notSaveDraft.title'
            : 'draft.notification.create.popup.title',
        })}
        isLoading={isLoadingButtonSubmit}
        body={formatMessage({
          id: isNotSaveDraft
            ? 'draft.notification.notSaveDraft.body'
            : 'draft.notification.create.popup.body',
        })}
        DiscardButton={
          <OutlinedButtons
            id={`cancel-create-or-draft-dialog`}
            color={CLOSE}
            onClick={() => {
              setIsDraftPopupSubmitting(true)
              onClose(false)
            }}
            disabled={isLoadingButtonSubmit}
            aria-checked={false}
          >
            <FormattedMessage id="createNotification.dialog.cancel.title" />
          </OutlinedButtons>
        }
        ConfirmButton={
          isNotSaveDraft ? (
            <ContainedButton
              id={`submit-editing-event-btn`}
              color={SECONDARY}
              onClick={() => setIsClosingDialogWarning(false)}
              disabled={isLoadingButtonSubmit}
              isLoading={isLoadingButtonSubmit}
              aria-disabled={isLoadingButtonSubmit}
            >
              <FormattedMessage id="createNotification.btn.editingEvent.text" />
            </ContainedButton>
          ) : (
            <ContainedButton
              id={`submit-create-draft-btn`}
              color={SECONDARY}
              onClick={() => {
                setIsDraftPopupSubmitting(true)
                // Ensure body is synced from editor if undefined
                const values = {
                  ...formik.values,
                  body:
                    formik.values.body ?? bodyEditor?.getHTML() ?? undefined,
                }
                submitDraft(values)
              }}
              disabled={isLoadingButtonSubmit}
              isLoading={isLoadingButtonSubmit}
              aria-disabled={isLoadingButtonSubmit}
            >
              <FormattedMessage id="createNotification.create.draft.title" />
            </ContainedButton>
          )
        }
      />
      {isOpenCredit &&
        (!isEmpty(formik.values.recipients) ||
          !isEmpty(formik.values.channels.channelIds)) && (
          <MessageCreditAlert
            isOpen={isOpenCredit}
            setIsOpen={closeCredit}
            subscriberCount={subscriberTotal}
            state={formik.values}
          />
        )}
      <GenerateTextWithAIDialog
        {...generateTextWithAI}
        isTourOpen={CMAITourRun}
      />
      <GenerateImageWithAIDialog {...generateImageWithAI} />
      <RateWithAIDialog
        {...rateWithAI}
        onErrorRetry={() => rateWithAI.onConfirmClick()}
        editorRef={bodyEditor}
      />
      <SubmitDialog
        open={isOpenSwitchDialog}
        title={formatMessage({
          id: isBeaconDialog
            ? 'composeDialog.switch.dialog.general.title'
            : 'composeDialog.switch.dialog.beacon.title',
        })}
        description={formatMessage({
          id: 'composeDialog.switch.dialog.body',
        })}
        submitText={formatMessage({
          id: isBeaconDialog
            ? 'composeDialog.button.switch.general'
            : 'composeDialog.button.switch.beacon',
        })}
        onSubmit={() => {
          handleSwitchDialog(isBeaconDialog ? GENERAL_DIALOG : BEACON_DIALOG)
        }}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => {
          setIsOpenSwitchDialog(false)
        }}
        className={classStyle.submitDialog}
        type={SECONDARY}
      />
      <SubmitDialog
        open={confirmBeaconCloseDialog}
        isLoading={isLoadingButtonSubmit}
        title={formatMessage({
          id: 'draft.notification.create.popup.title',
        })}
        description={formatMessage({
          id: 'createNotification.beacon.comfirm.close.text',
        })}
        submitText={formatMessage({
          id: 'action.confirm',
        })}
        onSubmit={() => onBeaconCofirmCloseDialog()}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => {
          setConfirmBeaconCloseDialog(false)
        }}
        className={classStyle.submitDialog}
        type={SECONDARY}
      />
      <SubmitDialog
        open={isAiCanceled || isAiExist}
        type={CANCEL}
        title={formatMessage({
          id: isAiCanceled
            ? 'ai.dialog.cancel.dialog.title'
            : 'ai.dialog.exist.dialog.title',
        })}
        description={formatMessage({
          id: isAiCanceled
            ? 'ai.dialog.exist.dialog.description'
            : 'ai.dialog.exist.dialog.description',
        })}
        submitText={formatMessage({
          id: 'ai.dialog.back.dialog.yes',
        })}
        onSubmit={onSubmitAiConfirmDialog}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={onCloseAiConfirmDialog}
      />
    </>
  )
}

export default React.memo(ComposeMessageDialog)
